import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'

export const IconRow = ({ icon, title, children }) => {
	const { data: tenantProfile } = useTenantProfile()
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<div style={{ display: 'flex', flexDirection: 'row', gap: 20 }}>
			<Icon
				size={28}
				icon={icon}
				solid
				color={secondaryColor}
				style={{ width: 20, height: 'fit-content' }}
			/>

			<div style={{ display: 'flex', flexDirection: 'column', marginTop: -8 }}>
				<Text size={22} style={{ fontWeight: 'bold' }}>
					{title}
				</Text>
				{children}
			</div>
		</div>
	)
}
